<div class="flat-select" [class.flex-wrap]="options?.length > 4 || wrapItems()">
  @for (option of options; track option.value; let i = $index) {
    <button
      role="radio"
      [attr.aria-checked]="isActive(option)"
      class="flat-select__item"
      [class]="{
        'flat-select__item--no-stretch': options?.length > 3 || !stretch(),
        active: isActive(option),
        readOnly: readonly() && isActive(option),
        disabled:
          disabled || (readonly() && !isActive(option)) || option.disabled,
        'd-none': option?.value?.id === 'default'
      }"
      (click)="selectOption(option)"
    >
      <div class="flat-select__label-container">
        <span
          class="flat-select__item-label"
          [class.can-be-deleted]="deletable()"
        >
          <div class="d-flex align-items-center justify-content-center">
            @if (icon()) {
              <div
                [class]="getIconClassName(icon())"
                class="flat-select__svg-icon"
              ></div>
            }
            <span>{{ returnValidLabel(option) | translate }}</span>
          </div>
        </span>
        @if (deletable() && (option?.value?.template || option?.value?.name)) {
          <button
            [attr.aria-label]="'general.delete_l' | translate"
            (click)="onRemove(i)"
          >
            <i class="icon icon--delete" aria-hidden="true"></i>
          </button>
        }
      </div>
    </button>
  }
  @if (showAddButton()) {
    <button im-button class="inverted" [disabled]="readonly()" (click)="add()">
      <i iconStart class="icon icon--add" aria-hidden="true"></i>
      {{ addButtonText() | translate }}
    </button>
  }
</div>
